import React from "react";
import classNames from "classnames";

interface Props {
	title?: string;
	headerOverride?: React.ReactNode;
	children?: React.ReactNode;
	className?: string;
}

const UtilityPanel: React.FC<Props> = (props) => {
	const header = props.headerOverride || (
		<div className="self-stretch inline-flex justify-start items-center gap-3">
			<div className="flex-1 justify-start text-black text-base font-normal font-['Inter']">
				{props.title}
			</div>
		</div>
	);

	return (
		<div className={classNames("max-h-[450px] overflow-y-auto self-stretch p-5 bg-white rounded-[5px] outline outline-2 outline-offset-[-2px] outline-slate-300 pge-blue flex flex-col justify-start items-start gap-px", props.className)}>
			{header}
			{props.children && (
				<div className="w-full text-xs mt-4">{props.children}</div>
			)}
		</div>
	);
};

export default UtilityPanel;
